<template>
    <div>
        <div class="header">
            <img src="@/assets/img/menu/next.png" class="back" @click="back">
            <div class="title">{{ AD.title }}</div>
        </div>
        <div class="content">
            <shop v-for="shop in AD.shops" :shop="shop" :key="shop.id"/>
        </div>
    </div>
</template>

<script>
    import Shop from './components/shop/ShopItem';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'AdShops',
        components: {
            'shop': Shop,
        },
        data() {
            return {
                id: 0,
            };
        },
        computed: {
            AD() {
                return this.ads.find(ad => ad.id === this.id) || {title: '', shops: []};
            },
            ...mapGetters(['ads'])
        },
        methods: {
            back() {
                if (window.history.length > 2) {
                    this.$router.go(-1);
                } else {
                    this.$router.push({
                        name: 'home',
                    });
                }
            },
            initAd() {
                if (! this.AD.title) {
                    this.$router.replace({ name: 'home' })
                }
                else if (this.AD.type === 'category') {
                    this.$router.replace({
                        name: 'ShopList',
                        query: {
                            title: this.AD.title,
                            'ADIds': Array.from(this.AD.categories.map(c => c.id).values()),
                        }
                    });
                }
                else if (this.AD.type === 'url') {
                    window.open(this.AD.url);

                    this.$router.replace({ name: 'home' });
                }
            },
            ...mapActions(['getAds'])
        },
        mounted() {
            this.id = parseInt(this.$route.params.id);
            this.getAds().then(() => {
                this.initAd();
            });
        }
    };
</script>

<style scoped>
    .header {
        padding: 15px;
        position: relative;
    }

    .title {
        height: 22px;
        color: rgba(0,0,0,1);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.34px;
        line-height: 22px;
        text-align: center;
    }

    .back {
        transform: rotateY(180deg);
        width: 20px;
        height: 20px;
        position: absolute;
        left: 10px;
    }

    .content {
        margin-bottom: 15px;
    }

    a {
        text-decoration: none;
    }
</style>
